import type {
  Column,
  ColumnOrderState,
  Header,
  Table as ReactTable,
} from '@tanstack/react-table'
import { flexRender } from '@tanstack/react-table'
import { useDrag, useDrop } from 'react-dnd'
import { FaBars } from 'react-icons/fa'

const reorderColumn = (
  draggedColumnId: string,
  targetColumnId: string,
  columnOrder: string[],
): ColumnOrderState => {
  columnOrder.splice(
    columnOrder.indexOf(targetColumnId),
    0,
    columnOrder.splice(columnOrder.indexOf(draggedColumnId), 1)[0],
  )
  return [...columnOrder]
}

export const DraggableColumnHeader = <T,>(props: {
  header: Header<T, unknown>
  table: ReactTable<T>
}) => {
  const { header, table } = props
  const { getState, setColumnOrder } = table
  const { columnOrder } = getState()
  const { column } = header

  const [, dropRef] = useDrop({
    accept: 'column',
    drop: (draggedColumn: Column<T>) => {
      const newColumnOrder = reorderColumn(
        draggedColumn.id,
        column.id,
        columnOrder,
      )
      setColumnOrder(newColumnOrder)
    },
  })

  const [{ isDragging }, dragRef, previewRef] = useDrag({
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => column,
    type: 'column',
  })

  return (
    <span ref={dropRef} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <span ref={previewRef}>
        <button ref={dragRef}><FaBars></FaBars></button>
        {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())}
      </span>
    </span>
  )
}
